

import { PanelsActionTypes } from 'actionsConstants';
import { dispatch, state } from '__common/store';
import { PUT_PANELS_IN_HISTORY } from 'actions';
import { PUT_LITE_PANELS_IN_HISTORY } from 'v3/workspace/history/liteHistoryActions';
import { DEBUG } from 'debug';

const actions = [
  PanelsActionTypes.REMOVE_PANELS,
  PanelsActionTypes.ADD_PANELS,
  PanelsActionTypes.CHANGE_SINGLE_PANEL_ROOF_ZONE,
];

const historyEnabled = () => DEBUG.enablePanelsUndo || DEBUG.enablePanelsRedo || state().app?.isUbuilderLite;

const shouldSeedInitialPanelsSnapshot = (history: historyState, panels: panelInState[] = []) => {
  return history.index === 0 &&
    history.panelsSnapshot.length === 1 &&
    history.panelsSnapshot[0].length === 0 &&
    panels.length > 0;
};

const compactPanelsForHistory = (panels: panelInState[] = []): panelInState[] => panels.map((panel) => {
  const {
    centerPoint,
    rTreeBounds,
    stickPoints,
    ...panelSnapshot
  } = panel;

  return {
    ...panelSnapshot,
  };
});

export const panelsHistoryMiddleware = store => next => action => {
  if (actions.includes(action.type) && historyEnabled()) {
    const { panels: { panels }, history } = state();

    if (shouldSeedInitialPanelsSnapshot(history, panels)) {
      dispatch(PUT_PANELS_IN_HISTORY(compactPanelsForHistory(panels)));
    }
  }

  next(action);

  if (actions.includes(action.type) && historyEnabled()) {
    const { panels: { panels } } = state();
    const compacted = compactPanelsForHistory(panels);
    // Lite uses its own slice + corrected reducer (drops the redo branch
    // and resets index on a new edit). Legacy DEBUG-flag path keeps using
    // the legacy slice so we don't change anything there.
    //
    // Note: newly-added panels may not have roofZone set yet at this
    // point (zone-recalculation epics run asynchronously after ADD_PANELS).
    // The zone-recalculation epics also listen for LOAD_PANELS_FROM_HISTORY,
    // so zones are corrected whenever a snapshot is restored via undo/redo.
    if (state().app?.isUbuilderLite) {
      dispatch(PUT_LITE_PANELS_IN_HISTORY(compacted));
    } else {
      dispatch(PUT_PANELS_IN_HISTORY(compacted));
    }
  }
};
